goog.provide("shadow.js.shim.module$$carbon$icons_react$es$SettingsAdjust$default");
shadow.js.shim.module$$carbon$icons_react$es$SettingsAdjust$default = shadow.js.require(372, {}).default;
